<h2 mat-dialog-title class="invite-title">
    <span class="title">Our Terms</span>
    <mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
  </h2>
  <div class="cadidate-welcome" appBlockCopyPaste>
    <div class="content-section">
      <!-- <mat-card class="welcome-info "> -->
        <div [innerHTML]="assessmentInfo?.welcomeTemplate?.content"></div>
        <div class="submit-section">
          <!-- <button mat-raised-button color="primary" class="proceed-assessment" (click)="proceedAssessment()">
            Proceed</button> -->
        </div>
      <!-- </mat-card> -->
    </div>
  </div>
<mat-dialog-actions class="close-btn">
    <button mat-button mat-dialog-close>close</button>
</mat-dialog-actions>